export function OpenBookIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7257 20.2286V5.4172M11.7257 20.2286L10.2682 18.7712C9.44522 17.9481 8.32946 17.4858 7.16554 17.4858H3.49618C2.89025 17.4858 2.39999 16.9946 2.39999 16.3886V4.86863C2.39999 4.26269 2.8912 3.77148 3.49714 3.77148H7.71362C8.87754 3.77148 9.99379 4.23385 10.8168 5.05687L11.7257 5.96577L12.6346 5.05687C13.4576 4.23385 14.5739 3.77148 15.7378 3.77148H20.5028C21.1088 3.77148 21.6 4.26269 21.6 4.86863V16.3886C21.6 16.9946 21.1088 17.4858 20.5028 17.4858H16.2864C15.1224 17.4858 14.0062 17.9481 13.1832 18.7712L11.7257 20.2286Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
